import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AitTransporteService } from 'app/services/mob/ait-transporte.service';
import { TalonarioAitSearch } from 'app/services/mob/talonario-ait.search';
@Component({
  selector: 'grid-recursos',
  templateUrl: './grid-recursos.component.html',
  styleUrls: ['./grid-recursos.component.scss']
})
export class GridRecursosComponent implements OnInit {
  
  columns: any[] = [
    { dataField: "nrDocumento", headerText: "Nº Recurso", width: "60px", labelFunction: this._getNrRecursoFunction },
    { dataField: "dtProtocolo", headerText: "Data de Abertura", width: "120px", labelFunction: this._getDtAberturaFunction },
    { dataField: "nmFase", headerText: "Fase", width: "240px", labelFunction: this._getFaseFunction },
    { dataField: "nmUsuario", headerText: "Usuário", width: "120px", labelFunction: this._getUsuarioFunction },
  ]

  get displayedColumns() {
    return this.columns.map((column) => column.dataField);
  }

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @Output() onFind: EventEmitter<TalonarioAitSearch> = new EventEmitter();
  @Output() rowClick = new EventEmitter();

  pageSize: number = 10;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  formGroup: FormGroup;
  cdAit: number;

  constructor(
    private _aitTransporteService: AitTransporteService,
    private _control: ControlContainer,
    private _router: Router,
    private _route: ActivatedRoute
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.formGroup = this._control.control as FormGroup;
    this.cdAit = this._route.snapshot.params['cdAit'];
    this.load();
  }

  load() {
    if (!this.cdAit)
      return;

    this._aitTransporteService.getAllRecursos(this.cdAit).then(recursoDTO => {
      this.dataSource = new MatTableDataSource(recursoDTO);
      this.dataSource.paginator = this.paginator;
    }).catch(e => console.log(e));
  }

  rowEditClick($event) {
    this._router.navigate(['recurso', $event.cdDocumento], {
      relativeTo: this._route
    });
  }

  private _getNrRecursoFunction(column, register: any) {
    if (register.nrDocumento) {
      return register.nrDocumento;
    }
    return '';
  }

  private _getDtAberturaFunction(column, register: any) {
    if (register.dtProtocolo) {
      return new Date(register.dtProtocolo).toLocaleDateString();
    }
    return '';
  }

  private _getFaseFunction(column, register: any) {

    if (register.cdFase) {
      return register.fase.nmFase;
    }
    return '';
  }

  private _getUsuarioFunction(column, register: any) {
    if (register.cdUsuario) {
      return register.usuario.nmLogin;
    }
    return '';
  }

}